import React, { useState } from "react";
import "./Navbar.scss";
import NavMenu from "./NavMenu";
import logo from "../assets/aplic-logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const currentPath = window.location.pathname;

  return (
    <nav className="nav-wrapper">
      <div className="nav-left">
        <a href="/" className="nav-logo-link">
          <img src={logo} alt="Logo" className="nav-logo" />
        </a>

        <div
          className={`logo-dropdown ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <span className="dropdown-arrow">{open ? "▲" : "▼"}</span>
        </div>

        {open && (
          <div className="logo-dropdown-menu active">
            <NavMenu closeMenu={() => setOpen(false)} />
            <div className="close-dropdown" onClick={() => setOpen(false)}>
              <span>▲</span>
            </div>
          </div>
        )}
      </div>

      <ul className="nav-menu">
        <li className={`tab tab-about ${currentPath === "/about-us" ? "active" : ""}`}>
          <a href="/about-us">About Us</a>
        </li>
        <li className={`tab tab-venue ${currentPath === "/venue" ? "active" : ""}`}>
          <a href="/venue">Venue</a>
        </li>
        <li className={`tab tab-agenda ${currentPath === "/agenda" ? "active" : ""}`}>
          <a href="/program">Program</a>
        </li>
        <li className={`tab tab-speakers ${currentPath === "/speakers" ? "active" : ""}`}>
          <a href="/speakers">Speakers</a>
        </li>
        <li className={`tab tab-whatsfun ${currentPath === "/whats-fun" ? "active" : ""}`}>
          <a href="/whats-fun">What’s Fun?</a>
        </li>
      </ul>

      <div className="nav-right">
        <button
          className="register-btn"
          onClick={() => window.open("https://aplic2027.gottit.io/", "_blank")}
        >
          Register Now
        </button>

        <div className="mobile-burger" onClick={() => setMobileOpen(!mobileOpen)}>
          <span className="burger-symbol">{mobileOpen ? "✕" : "☰"}</span>
        </div>
      </div>

      {mobileOpen && (
        <div className="mobile-menu">
          <a href="/about-us" onClick={() => setMobileOpen(false)}>About Us</a>
          <a href="/venue" onClick={() => setMobileOpen(false)}>Venue</a>
          <a href="/program" onClick={() => setMobileOpen(false)}>Program</a>
          <a href="/speakers" onClick={() => setMobileOpen(false)}>Speakers</a>
          <a href="/whats-fun" onClick={() => setMobileOpen(false)}>What’s Fun?</a>
        </div>
      )}
    </nav>
  );
}
